import React, { useState, useEffect } from "react";
import FormatDateTime from "../../utils/formatDateTime";
import { ChevronsUpDownIcon } from "lucide-react";

const EventsCalendarTable = ({ data }) => {
  const [sortField, setSortField] = useState("date"); // Set an initial sort field
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedData, setSortedData] = useState([]);

  // Use effect to sort data when sortField or sortOrder changes
  useEffect(() => {
    const sorted = [...data]?.sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      // Parse dates for comparison if the sort field is "date"
      if (sortField === "date") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
      if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

    setSortedData(sorted);
  }, [data, sortField, sortOrder]);

  const handleSort = (field) => {
    if (sortField === field) {
      // Toggle sort order if the same column is clicked
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Set the new sort field and default to ascending order
      setSortField(field);
      setSortOrder("asc");
    }
  };

  return (
    <div className="z-0 w-full font-poppins h-[calc(100vh-60px)] border-t-[1px] border-gray-800 custom-scroll overflow-x-auto shadow-md animate-reveal transition-all duration-500 ease-in">
      <table className="bg-black text-sm w-full relative z-0">
        <thead className="sticky top-0 bg-[#0F0F0F] text-sm text-left">
          <tr className="text-white border-b border-gray-800">
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              S.No
            </th>
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Symbol
              <ChevronsUpDownIcon
                onClick={() => handleSort("symbol")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Company
              <ChevronsUpDownIcon
                onClick={() => handleSort("company")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Purpose
              <ChevronsUpDownIcon
                onClick={() => handleSort("purpose")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="border-r w-[150px] last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Date
              <ChevronsUpDownIcon
                onClick={() => handleSort("date")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="border-r w-[450px] last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Description
              <ChevronsUpDownIcon
                onClick={() => handleSort("bm_desc")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData && sortedData.length > 0 ? (
            sortedData.map((ele, i) => (
              <tr key={i} className="text-white border-b border-gray-800">
                <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {i + 1}
                </td>
                <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.symbol}
                </td>
                <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.company}
                </td>
                <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.purpose}
                </td>
                <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.date}
                </td>
                <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.bm_desc}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="4"
                rowSpan="20"
                className="px-4 py-20 text-center text-white text-[20px] font-medium"
              >
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EventsCalendarTable;
